import { Switch } from 'antd';
import './SwitchComponent.scss';

const SwitchComponent = ({
  onChange,
  size = 'large',
  id,
  label,
  value,
  disabled,
  ...props
}) => {
  return (
    <div className="toggle" onClick={e => e.stopPropagation()}>
      <Switch
        onChange={onChange}
        size={size}
        id={id}
        value={value}
        disabled={disabled}
        {...props}
      />
      {label && <label htmlFor={id}>{label}</label>}
    </div>
  );
};

export default SwitchComponent;
